import { z } from 'zod';

export const shipperServiceCodeV21Schema = z.object({
    label: z.string().describe('Human-readable service name for UI.'),
    value: z.string().describe('Value for shipperServiceCode on orders.'),
    shipper: z.string().describe('Value for shipper on orders.'),
    isExpedition: z.boolean().describe('Whether the service can be used for outbound orders.'),
    isReturn: z.boolean().describe('Catalog flag. Return shipments use free-text shipper, not this list.'),
}).strict();

export type ShipperServiceCodeV21 = z.infer<typeof shipperServiceCodeV21Schema>;
